import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
const QatarReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Qatar Attestation:</h3>
        <p>
          Certificate attestation for Qatar visa is required for various areas
          such as student visa, work visa, residence visa, or for professional
          purposes. It is a part of the evidence that shows that you are a
          legitimate person or company. It proves that your certificates are
          genuine & can be permitted in the country.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get certificate attestation for Qatar:</h3>
        <p>
          The time span needed for Certificate attestation for Qatar is based on
          various reasons such as which country you mandate the legalization
          for, or the kinds of documents, or the state you require it from.
          Generally, it will take about 7 to 10 days to finish.
        </p>
      </div>
    </div>
  );
};

export default QatarReqMain;
